import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyConsignee = ({
    value,
    handleChange,
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        !props.preventInitialLoading && 
        ReadAxios({ url: 'consigneeMaster' })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])

    const handleSearch = (e, data) => {
        setloading(true)
        let searchTerm = data.searchQuery
        ReadAxios({ url: 'consigneeMaster', readItems: { searchTerm: searchTerm } })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }
    let options = []
    if (content?.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.consigneeId
            temp.text = `${object.consigneeName} (${object.consigneeCode})`
            temp.value = props.codeValue ? object.consigneeCode : object.consigneeId
            return options[index] = temp
        })
    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%', display: 'inline-table' }}
            onChange={handleChange}
            options={options}
            clearable
            onSearchChange={handleSearch}
            value={value}
        />
    )
}

export default MyConsignee